import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";
import { AdminTitle } from "./AdminLayout";

const CARDS = [
  ["new_inquiries", "Nye henvendelser", "/admin/henvendelser"],
  ["unapproved_prices", "Priser som venter på godkjenning", "/admin/priser"],
  ["chat_sessions", "AI-samtaler", "/admin/samtaler"],
  ["drafts", "Markedsføringsutkast", "/admin/markedsforing"],
];

const INTEREST = [["gruppekurs", "Gruppekurs – 4 timer"], ["nettkurs", "Nettkurs"], ["pakke", "Sykurs + digital håndbok"], ["bok", "Håndbok"]];

const InterestBox = ({ i }) => (
  <section className="mt-10" data-testid="interest-overview">
    <h2 className="text-2xl font-medium">Interesse for kommende tilbud</h2>
    <p className="text-sm text-[#5C5A56] mt-1">Antall som har meldt interesse (gratis og uforpliktende). Hjelper deg å velge hva du starter med.</p>
    <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-4 mt-5">
      {INTEREST.map(([k, label]) => (
        <Link key={k} to={`/admin/henvendelser?type=${k}`} className="border border-[#E5E0D8] p-6 hover:bg-[#F0EBE1] transition-colors" data-testid={`interest-${k}`}>
          <p className="font-serif-display text-5xl">{i ? i[k] : "–"}</p>
          <p className="text-sm text-[#5C5A56] mt-2">{label}</p>
        </Link>
      ))}
    </div>
  </section>
);

export default function Overview() {
  const [s, setS] = useState(null);
  useEffect(() => { http.get("/admin/stats").then((r) => setS(r.data)); }, []);
  return (
    <div data-testid="admin-overview">
      <AdminTitle title="Oversikt" sub="Velkommen, Liisa. Her ser du det viktigste som venter på deg." />
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 border-l border-t border-[#E5E0D8]">
        {CARDS.map(([k, label, to]) => (
          <Link key={k} to={to} className="p-8 border-r border-b border-[#E5E0D8] hover:bg-[#F0EBE1] transition-colors" data-testid={`stat-${k}`}>
            <p className="font-serif-display text-6xl">{s ? s[k] : "–"}</p>
            <p className="text-sm text-[#5C5A56] mt-2">{label}</p>
          </Link>
        ))}
      </div>
      <InterestBox i={s?.interest} />
      {s?.unapproved_prices > 0 && (
        <p className="mt-8 p-5 bg-[#F0EBE1] border-l-2 border-[#C4A47C] text-sm" data-testid="price-warning">
          {s.unapproved_prices} priser er hentet fra den gamle prislisten og vises som «Pris etter vurdering» på nettsiden til du godkjenner dem under <Link to="/admin/priser" className="underline">Priser</Link>.
        </p>
      )}
    </div>
  );
}
